import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { GatsbyImage } from 'gatsby-plugin-image'
import * as styles from './index.module.css'

export default class PanoramicImage extends Component {
  constructor(props) {
    super(props)

    this.state = {
      scrollPosition: 0,
      triggerPosition: 0,
      triggered: false,
      scalarScroll: 0,
    }
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll)

    var clientRect = ReactDOM.findDOMNode(this).getBoundingClientRect()
    this.state.triggerPosition = clientRect.top
  }

  handleScroll = () => {
    if (typeof window !== undefined) {
      var windowScrollBottom = window.pageYOffset + window.innerHeight * 0.6

      this.state.scrollPosition = windowScrollBottom

      if (
        windowScrollBottom > this.state.triggerPosition &&
        this.state.triggered == false
      ) {
        this.state.triggered = true
      }

      const scrollPercent = 50

      var scalarScroll =
        ((this.state.scrollPosition - this.state.triggerPosition) /
          window.innerHeight) *
        20
      scalarScroll = Math.min(scalarScroll, 20) // Clamp
      scalarScroll = Math.max(scalarScroll, 0)
      this.state.scalarScroll = scalarScroll

      this.setState(this.state)
    }
  }

  render() {
    var props = this.props

    var textPan = {
      top: (20 - this.state.scalarScroll) * 0.6 + '%',
    }
    var imagePan = {
      top: this.state.scalarScroll * 0.8 + '%',
    }

    return (
      <div className={styles.panoramicContainer}>
        <div className="wrapper">
          <div
            className={
              styles.container +
              ' ' +
              (this.state.triggered ? styles.visible : '')
            }
          >
            <div className={styles.textContainer} style={textPan}>
              <h3 className={styles.title}>{props.title}</h3>
              <div className={styles.subtitle}>{props.subtitle.subtitle}</div>
            </div>

            <div className={styles.imageContainer} style={imagePan}>
              <GatsbyImage
                image={props.images[0].gatsbyImageData}
                className={styles.image}
                imgStyle={{ objectFit: 'cover' }}
                alt={props.images[0]?.description}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}
